<template>
  <div>
    <!-- 面包屑 -->
    <!-- <div class="position container yu_fc particles_box">
      <router-link to="/">首页</router-link>
      <a href="javascript:void(0)" class="title">{{ title }}</a>
      {{ goodsTitle }}
    </div> -->
    <!-- 数据 -->
    <div class="detail_base container yu_fc yu_pr particles_box">
      <div class="left_img">
        <div class="top_img">
          <my-magnify :previewImg="currImg" :zoomImg="currImg"></my-magnify>
        </div>
        <div class="bottom_img">
          <li
            v-for="(item, index) in banArr"
            :key="index"
            @mouseenter="onImg(item, index)"
            :class="currNum == index ? 'active' : ''"
          >
            <img :src="item" />
            <!-- {{currNum}}/{{index}} -->
          </li>
        </div>
      </div>
      <div class="right_txt">
        <h3 class="title_z"><span v-if="goodsabroad == 1">海外</span>{{goodsTitle}}</h3>
        <h3 class="title_f">{{goodsName}}</h3>
        <!-- 价格/配送 -->
        <div class="price_deliv">
          <span1 name="span11">价格</span1>
          <span2 name="span12">￥</span2>
          <span3 name="span13">{{goodsPrice}}</span3>
          <span4 name="span14">市场价￥{{goodsOriginalPrice}}</span4>
        </div>
        <div class="price_pref">
          <span1 name="span21">优惠</span1>
          <span2 name="span22">折扣</span2>
          <span3 name="span23">下单可减</span3>
          <span4 name="span24">￥{{goodsDiscountPrice}}</span4>
          <span5 name="span25">利润</span5>
          <span6 name="span26">客户下单可得利润</span6>
          <span7 name="span27">￥{{goodsCashbackPrice}}</span7>
        </div>
        <div class="goods_deliv">
          <span1 name="span31">配送</span1>
          <div class="address_no" v-if="goodsAddress.length == 0" @click="addressAdd">添加地址</div>
          <div class="address_list" v-if="goodsAddress.length != 0">
            <select @change="getAddr" name="addr">
              <option
                v-for="(item , index) in goodsAddress"
                :value="item.id"
                :key="index"
              >{{addrInter(addrSplit(item.addrNameFull)+""+item.detailAddress)}}</option>
            </select>
          </div>
          <span2 name="span32">快递:￥{{freightAmount}}</span2>
        </div>
        <div class="goods_serv">
          <span1 name="span41">服务</span1>
          <span2 name="span42">7天无理由退货 · 极速退款 · 不支持</span2>
        </div>
        <!-- <div class="goods_weight">
          <span1>重量</span1>
          <span2>7天无理由退货 · 极速退款 · 不支持</span2>
        </div> -->
        <!-- <div class="goods_num">
          <span1>数量</span1>
          <div class="right">
            <div class="number">
              <div class="minus" :class="number <= 1 ? 'active' : ''" @click="minus">-</div>
              <div class="num">
                <input
                  type="text"
                  @input="onInput"
                  @blur="onBlur"
                  v-model="number"
                  :disabled="disableds"
                />
              </div>
              <div class="add" :class="number >= 99 || number == 0 ? 'active' : ''" @click="add">+</div>
            </div>
          </div>
        </div> -->
        <div class="model_list" v-for="(item , index) in modelArr" :key="index">
          <div class="left">{{item.attr}}</div>
          <div class="right">
            <!-- <span
              v-for="(items , indes) in item.value"
              :key="indes"
              @click="onModel(item.id,item.name,items,index)"
            > -->
            <span
              v-for="(items , indes) in item.value"
              :key="indes"
              @click="onModel0(index,indes,items)"
            >
              <p
                class="on_show"
                v-if="(items['sp'] == parSet1 && index == 0) || 
                (items['sp'] == parSet2 && index == 1) || 
                (items['sp'] == parSet3 && index == 2) || 
                (items['sp'] == parSet4 && index == 3) || 
                (items['sp'] == parSet5 && index == 4)"
              >
                {{items['sp']}}
                <i v-if="iconShow"></i>
              </p>
              <p
                class="on_hide"
                v-if="!(items['sp'] == parSet1 && index == 0)
                || !(items['sp'] == parSet2 && index == 1)
                || !(items['sp'] == parSet3 && index == 2)
                || !(items['sp'] == parSet4 && index == 3)
                || !(items['sp'] == parSet5 && index == 4)"
              >{{items['sp']}}</p>
            </span>
          </div>
        </div>
        <div class="goods_num">
          <span1>数量</span1>
          <div class="right">
            <div class="number">
              <div class="minus" :class="number <= 1 ? 'active' : ''" @click="minus">-</div>
              <div class="num">
                <input
                  type="text"
                  @input="onInput"
                  @blur="onBlur"
                  v-model="number"
                  :disabled="disableds"
                />
              </div>
              <div class="add" :class="number >= 99 || number == 0 ? 'active' : ''" @click="add">+</div>
            </div>
          </div>
        </div>
        <!-- <div class="model_list">
          <div class="left">数量</div>
          <div class="right">
            <div class="number">
              <div class="minus" :class="number <= 1 ? 'active' : ''" @click="minus">-</div>
              <div class="num">
                <input
                  type="text"
                  @input="onInput"
                  @blur="onBlur"
                  v-model="number"
                  :disabled="disableds"
                />
              </div>
              <div class="add" :class="number >= 99 || number == 0 ? 'active' : ''" @click="add">+</div>
            </div>
          </div>
        </div> -->
        <div class="btn">
          <div class="btn_car" :class="number == '0' ? 'active' : ''" @click="onCar">
            <p>加入购物车</p>
          </div>
          <div class="btn_pay" :class="number == '0' ? 'active' : ''" @click="onPay">
            <p>立即购买</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 数据 -->
    <!-- 详情/评价 -->
    <div class="goods_detail container yu_fc yu_pr particles_box">
      <div class="item_list">
        <li v-for="(item, index) in goodsArr" :key="index">
          <a href="javascript:void(0)" class="img" @click="onGoodsDetail(item.id,item.defaultSkuId,item.name, '为你推荐')"><img :src="item.pic" /></a>
          <a href="javascript:void(0)" class="title" @click="onGoodsDetail(item.id,item.defaultSkuId,item.name, '为你推荐')">{{item.name}}</a>
          <div class="price">
            <span>￥{{item.price}}</span>
            <del>￥{{item.originalPrice}}</del>
          </div>
        </li>
      </div>
      <div class="detail_comment">
        <el-tabs v-model="detailName" @tab-click="detailEvalua">
          <el-tab-pane label="商品详情" name="detail">
            <div class="detail" v-html="goodsDetail"></div>
          </el-tab-pane>
          <!-- <el-tab-pane :label="'商品评价（' + goodsComment +'）'" name="evalua">
            <Evalbox :evalNum="goodsRate" :gooodId="id" :goodEval="goodsEval" :imgEval="banArr"></Evalbox>
          </el-tab-pane> -->
        </el-tabs>
      </div>
    </div>
    <!-- 详情 -->
    <!-- 添加地址 -->
    <!-- <div class="yu_mask" v-if="addressShow == 1">
      <div class="address_add">
        <h3 class="title">添加地址</h3>
        <div class="label">
          <div class="left">所在地区：</div>
          <div class="right">
            <v-distpicker :placeholders="placeholders" @selected="onSelected"></v-distpicker>
          </div>
        </div>
        <div class="label">
          <div class="left">详情地址：</div>
          <textarea
            placeholder="请填写您的详细地址、街道、门牌号"
            v-model="addressDetail"
            @focus="addressDetailFocus"
          ></textarea>
          <div class="errmes" v-if="addressDetailShow == 1">
            <i></i>详细地址不能为空
          </div>
        </div>
        <div class="label width yu_fl">
          <div class="left">收货人：</div>
          <input type="text" v-model="addressName" @focus="addressNameFocus" />
          <div class="errmes" v-if="addressNameShow == 1">
            <i></i>收货人不能为空
          </div>
        </div>
        <div class="label width yu_fr">
          <div class="left">手机号码：</div>
          <input type="text" maxlength="11" v-model="addressPhone" @focus="addressPhoneFocus" />
          <div class="errmes" v-if="addressPhoneShow == 1">
            <i></i>
            {{addressPhoneMessage}}
          </div>
        </div>
        <div class="labtl_btn">
          <div class="default" :class="defaults == 1 ? 'active' : ''" @click="onDefault">
            <i></i>设为默认
          </div>
          <div class="btns btns_close" @click="addressClose">取消</div>
          <div class="btns btns_submit" @click="onSubmit">确定</div>
        </div>
      </div>
      <div class="yu_back" @click="addressClose"></div>
    </div> -->
    <div>
      <img v-if='img_show' class="img_position1" src="../assets/images/sjp_xcx.jpg" />
    </div>
  </div>
</template>

<script>
import MyMagnify from '../components/Magnify'
import Evalbox from '../components/evalbox'
import VDistpicker from 'v-distpicker'
import { productList,productSkuInfo,productCommentList } from '@/api/product'
//import { productInfo, productSkuInfo,productCommentList } from '@/api/product'
import { addrList, addrAdd } from '@/api/address'
import { cartAdd } from '@/api/cart'
export default {
  name: 'goodsDetail',
  components: {
    MyMagnify,
    Evalbox,
    VDistpicker,
  },
  data() {
    return {
      img_show: false,
      id: '', // id
      skuId: '',
      title: '', // 名字
      classId: '', // 一级分类id
      banArr: [], // 轮播图组
      currImg: '', // 默认当前第一张图片
      currNum: '01', // 鼠标经过的第几张图片
      goodsTitle: '', // 商品一级标题
      goodsName: '', // 商品二级标题
      goodsPrice: '', // 商品价格
      goodsOriginalPrice: '', // 商品价格
      goodsDiscountPrice: '', 
      goodsCashbackPrice: '', 
      freightAmount: 0, 
      goodsSnId: '', // 商品库存id
      goodsStock: '', // 商品库存
      goodsComment: 0, // 商品评价数
      goodsRate: 0, // 商品好评率
      goodsAddress: [], // 收货地址
      detailName: 'detail', // 商品详情/商品评价
      goodsDetail: '', // 商品详情
      goodsEval: [], // 商品评价
      goodsabroad: 0, // 是否海外实名 0 否 1是
      addressShow: 0, // 是否显示添加地址
      placeholders: {
        province: '请选择',
        city: '请选择',
        area: '请选择',
      },
      areaCode: '',
      addressName: '', // 收件人
      addressNameShow: 0,
      addressPhone: '', // 收件人电话
      addressPhoneShow: 0,
      addressPhoneMessage: '',
      addressDetail: '', // 详情地址
      addressDetailShow: 0,
      addressId: '', // 当前选择地址id
      defaults: 0, // 默认地址
      disableds: false, //规格为0，禁止选择
      number: 1, // 数量
      iconShow: false, // 选中标注
      modelArr: [], // 规格
      modelSku: [], // 规格库存
      goodsArr: [], // 推荐
      parSet1: '',
      parSet2: '',
      parSet3: '',
      parSet4: '',
      parSet5: '',
    }
  },
  created() {
    this.id = this.$route.query.id
    this.skuId = this.$route.query.skuId
    this.title = localStorage.getItem('className')
    this.classId = localStorage.getItem('classId')
    console.log(this.classId)
    localStorage.removeItem('addressId')
    this.getGoods()
    this.getAddress()
    this.loadEvalu()
  },
  methods: {
    onSelected(data) {
      this.areaCode = data.area.code
      console.log(this.areaCode)
    },
    // 商品数据
    async getGoods() {
      //const res = await productInfo(this.id)

     const res0 = await productList({
        tabStatus: 3,
        pageSize: 10,
        pageNum: 1,
        order: 1
      })
      console.log(res0);
      if (res0.code == 200) {
        this.goodsArr = res0.data.list;
      }

      let params = {
        id: this.id,
        skuId: this.skuId
      };
      const res = await productSkuInfo(this.id,params)
      console.log(res)
      if (res.code == 200) {
        this.banArr = res.data.picArr.concat(res.data.picArr)
        this.currImg = res.data.picArr[0]
        this.goodsTitle = res.data.name
        this.goodsName = res.data.subTitle
        this.goodsPrice = res.data.skuStockDefault.price//res.data.price
        this.goodsOriginalPrice = res.data.skuStockDefault.originalPrice
        this.goodsDiscountPrice = res.data.skuStockDefault.discountPrice
        this.goodsCashbackPrice = res.data.skuStockDefault.cashbackPrice
        this.goodsComment = res.data.comment
        this.goodsRate = res.data.commentRate
        //this.goodsDetail = res.data.detailHtml
        this.goodsDetail = res.data.detailMobileHtml
        this.modelArr = res.data.skuStockAttrList//res.data.productAttrList
        this.modelSku = res.data.skuStockList
        this.goodsabroad = res.data.houniaoAbroadStatus
        //this.defaultModel(res.data.productAttrList.length)
        this.defaultModel0(res.data.skuStockDefault.attrNote)
      }
    },
    // 商品详情
    onGoodsDetail(id, skuId, proId, title) {
      console.log(id, skuId, proId, title);
      let router = this.$router.resolve({
        path: "/goodsDetail",
        query: {
          id: id,
          skuId: skuId
        }
      });
      window.open(router.href, "_self");
      // this.$router.push({
      //   path: "/goodsDetail",
      //   query: {
      //     id: id,
      //     skuId: skuId
      //   }
      // }, (err) => {err});

      let classId = proId + "";
      localStorage.setItem("className", title);
      localStorage.setItem("classId", classId.substring(0, 2));
      location. reload()
    },
    defaultModel0(str) {
      let strData = str.split(',')
      if (strData.length == 1) {
        this.parSet1 = strData[0]
      } else if (strData.length == 2) {
        this.parSet1 = strData[0]
        this.parSet2 = strData[1]
      } else if (strData.length == 3) {
        this.parSet1 = strData[0]
        this.parSet2 = strData[1]
        this.parSet3 = strData[2]
      } else if (strData.length == 4) {
        this.parSet1 = strData[0]
        this.parSet2 = strData[1]
        this.parSet3 = strData[2]
        this.parSet4 = strData[3]
      } else if (strData.length == 5) {
        this.parSet1 = strData[0]
        this.parSet2 = strData[1]
        this.parSet3 = strData[2]
        this.parSet4 = strData[3]
        this.parSet5 = strData[4]
      }
      return
    },
    // 默认第一个选中
    defaultModel(num) {
      let _this = this
      console.log(_this.modelSku)
      switch (num) {
        case 1:
          for (var i = 0; i < _this.modelSku.length; i++) {
            _this.parSet1 = _this.modelSku[0].sp1
            if (_this.parSet1 != '') {
              if (_this.parSet1 == _this.modelSku[i].sp1) {
                _this.goodsPrice = _this.modelSku[i].price
                _this.goodsSnId = _this.modelSku[i].id
                _this.goodsStock = _this.modelSku[i].stock
                _this.iconShow = true
                _this.number = 1
                _this.disableds = false
                return
              } else {
                _this.number = 0
                _this.disableds = true
                console.log('-----1-----')
              }
            }
          }
          break
        case 2:
          for (var i = 0; i < _this.modelSku.length; i++) {
            _this.parSet1 = _this.modelSku[0].sp1
            _this.parSet2 = _this.modelSku[0].sp2
            if (_this.parSet1 != '' && _this.parSet2 != '') {
              if (
                _this.parSet1 == _this.modelSku[i].sp1 &&
                _this.parSet2 == _this.modelSku[i].sp2
              ) {
                _this.goodsPrice = _this.modelSku[i].price
                _this.goodsSnId = _this.modelSku[i].id
                _this.goodsStock = _this.modelSku[i].stock
                _this.iconShow = true
                _this.number = 1
                _this.disableds = false
                return
              } else {
                _this.number = 0
                _this.disableds = true
                console.log('-----2-----')
              }
            }
          }
          break
        case 3:
          for (var i = 0; i < _this.modelSku.length; i++) {
            _this.parSet1 = _this.modelSku[0].sp1
            _this.parSet2 = _this.modelSku[0].sp2
            _this.parSet3 = _this.modelSku[0].sp3
            if (
              _this.parSet1 != '' &&
              _this.parSet2 != '' &&
              _this.parSet3 != ''
            ) {
              if (
                _this.parSet1 == _this.modelSku[i].sp1 &&
                _this.parSet2 == _this.modelSku[i].sp2 &&
                _this.parSet3 == _this.modelSku[i].sp3
              ) {
                _this.goodsPrice = _this.modelSku[i].price
                _this.goodsSnId = _this.modelSku[i].id
                _this.goodsStock = _this.modelSku[i].stock
                _this.iconShow = true
                _this.number = 1
                _this.disableds = false
                return
              } else {
                _this.number = 0
                _this.disableds = true
                console.log('-----3-----')
              }
            }
          }
          break
        case 4:
          for (var i = 0; i < _this.modelSku.length; i++) {
            _this.parSet1 = _this.modelSku[0].sp1
            _this.parSet2 = _this.modelSku[0].sp2
            _this.parSet3 = _this.modelSku[0].sp3
            _this.parSet4 = _this.modelSku[0].sp4
            if (
              _this.parSet1 != '' &&
              _this.parSet2 != '' &&
              _this.parSet3 != '' &&
              _this.parSet4 != ''
            ) {
              if (
                _this.parSet1 == _this.modelSku[i].sp1 &&
                _this.parSet2 == _this.modelSku[i].sp2 &&
                _this.parSet3 == _this.modelSku[i].sp3 &&
                _this.parSet4 == _this.modelSku[i].sp4
              ) {
                _this.goodsPrice = _this.modelSku[i].price
                _this.goodsSnId = _this.modelSku[i].id
                _this.goodsStock = _this.modelSku[i].stock
                _this.iconShow = true
                _this.number = 1
                _this.disableds = false
                return
              } else {
                _this.number = 0
                _this.disableds = true
                console.log('-----4-----')
              }
            }
          }
          break
        case 5:
          for (var i = 0; i < _this.modelSku.length; i++) {
            _this.parSet1 = _this.modelSku[0].sp1
            _this.parSet2 = _this.modelSku[0].sp2
            _this.parSet3 = _this.modelSku[0].sp3
            _this.parSet4 = _this.modelSku[0].sp4
            _this.parSet5 = _this.modelSku[0].sp5
            if (
              _this.parSet1 != '' &&
              _this.parSet2 != '' &&
              _this.parSet3 != '' &&
              _this.parSet4 != ''
            ) {
              if (
                _this.parSet1 == _this.modelSku[i].sp1 &&
                _this.parSet2 == _this.modelSku[i].sp2 &&
                _this.parSet3 == _this.modelSku[i].sp3 &&
                _this.parSet4 == _this.modelSku[i].sp4 &&
                _this.parSet5 == _this.modelSku[i].sp5
              ) {
                _this.goodsPrice = _this.modelSku[i].price
                _this.goodsSnId = _this.modelSku[i].id
                _this.goodsStock = _this.modelSku[i].stock
                _this.iconShow = true
                _this.number = 1
                _this.disableds = false
                return
              } else {
                _this.number = 0
                _this.disableds = true
                console.log('-----5-----')
              }
            }
          }
          break
        default:
          console.log('0')
          break
      }
    },
    // 选择规格
    onModel0(index,indes,items) {
      if (index == 0) {
        this.parSet1 = items['sp']
      } else if (index == 1) {
        this.parSet2 = items['sp']
      } else if (index == 2) {
        this.parSet3 = items['sp']
      } else if (index == 3) {
        this.parSet4 = items['sp']
      } else if (index == 4) {
        this.parSet5 = items['sp']
      }
      return
    },
    onModel(id, key, name, index) {
      let _this = this
      console.log(index)
      if (_this.modelSku.length == 0) {
        console.log('当前商品无库存')
        return false
      }
      switch (_this.modelArr.length) {
        case 1:
          for (var i = 0; i < _this.modelSku.length; i++) {
            if (name == _this.modelSku[i].sp1) {
              _this.parSet1 = name
            } else {
              if (id == _this.modelArr[0].id) {
                _this.parSet1 = name
              }
            }
            if (_this.parSet1 != '') {
              if (_this.parSet1 == _this.modelSku[i].sp1) {
                _this.goodsPrice = _this.modelSku[i].price
                _this.goodsSnId = _this.modelSku[i].id
                _this.goodsStock = _this.modelSku[i].stock
                _this.iconShow = true
                _this.number = 1
                _this.disableds = false
                return
              } else {
                _this.number = 0
                _this.disableds = true
                console.log('-----1-----')
              }
            }
          }
          break
        case 2:
          for (var i = 0; i < _this.modelSku.length; i++) {
            if (name == _this.modelSku[i].sp1) {
              _this.parSet1 = name
            } else {
              if (id == _this.modelArr[0].id) {
                _this.parSet1 = name
              }
            }
            if (name == _this.modelSku[i].sp2) {
              _this.parSet2 = name
            } else {
              if (id == _this.modelArr[1].id) {
                _this.parSet2 = name
              }
            }
            if (_this.parSet1 != '' && _this.parSet2 != '') {
              if (
                _this.parSet1 == _this.modelSku[i].sp1 &&
                _this.parSet2 == _this.modelSku[i].sp2
              ) {
                _this.goodsPrice = _this.modelSku[i].price
                _this.goodsSnId = _this.modelSku[i].id
                _this.goodsStock = _this.modelSku[i].stock
                _this.iconShow = true
                _this.number = 1
                _this.disableds = false
                return
              } else {
                _this.number = 0
                _this.disableds = true
                console.log('-----2-----')
              }
            }
          }
          break
        case 3:
          for (var i = 0; i < _this.modelSku.length; i++) {
            if (name == _this.modelSku[i].sp1) {
              _this.parSet1 = name
            } else {
              if (id == _this.modelArr[0].id) {
                _this.parSet1 = name
              }
            }
            if (name == _this.modelSku[i].sp2) {
              _this.parSet2 = name
            } else {
              if (id == _this.modelArr[1].id) {
                _this.parSet2 = name
              }
            }
            if (name == _this.modelSku[i].sp3) {
              _this.parSet3 = name
            } else {
              if (id == _this.modelArr[2].id) {
                _this.parSet3 = name
              }
            }
            if (
              _this.parSet1 != '' &&
              _this.parSet2 != '' &&
              _this.parSet3 != ''
            ) {
              if (
                _this.parSet1 == _this.modelSku[i].sp1 &&
                _this.parSet2 == _this.modelSku[i].sp2 &&
                _this.parSet3 == _this.modelSku[i].sp3
              ) {
                _this.goodsPrice = _this.modelSku[i].price
                _this.goodsSnId = _this.modelSku[i].id
                _this.goodsStock = _this.modelSku[i].stock
                _this.iconShow = true
                _this.number = 1
                _this.disableds = false
                return
              } else {
                _this.number = 0
                _this.disableds = true
                console.log('-----3-----')
              }
            }
          }
          break
        case 4:
          for (var i = 0; i < _this.modelSku.length; i++) {
            if (name == _this.modelSku[i].sp1) {
              _this.parSet1 = name
            } else {
              if (id == _this.modelArr[0].id) {
                _this.parSet1 = name
              }
            }
            if (name == _this.modelSku[i].sp2) {
              _this.parSet2 = name
            } else {
              if (id == _this.modelArr[1].id) {
                _this.parSet2 = name
              }
            }
            if (name == _this.modelSku[i].sp3) {
              _this.parSet3 = name
            } else {
              if (id == _this.modelArr[2].id) {
                _this.parSet3 = name
              }
            }
            if (name == _this.modelSku[i].sp4) {
              _this.parSet4 = name
            } else {
              if (id == _this.modelArr[3].id) {
                _this.parSet4 = name
              }
            }
            if (
              _this.parSet1 != '' &&
              _this.parSet2 != '' &&
              _this.parSet3 != '' &&
              _this.parSet4 != ''
            ) {
              if (
                _this.parSet1 == _this.modelSku[i].sp1 &&
                _this.parSet2 == _this.modelSku[i].sp2 &&
                _this.parSet3 == _this.modelSku[i].sp3 &&
                _this.parSet4 == _this.modelSku[i].sp4
              ) {
                _this.goodsPrice = _this.modelSku[i].price
                _this.goodsSnId = _this.modelSku[i].id
                _this.goodsStock = _this.modelSku[i].stock
                _this.iconShow = true
                _this.number = 1
                _this.disableds = false
                return
              } else {
                _this.number = 0
                _this.disableds = true
                console.log('-----4-----')
              }
            }
          }
          break
        case 5:
          for (var i = 0; i < _this.modelSku.length; i++) {
            if (name == _this.modelSku[i].sp1) {
              _this.parSet1 = name
            } else {
              if (id == _this.modelArr[0].id) {
                _this.parSet1 = name
              }
            }
            if (name == _this.modelSku[i].sp2) {
              _this.parSet2 = name
            } else {
              if (id == _this.modelArr[1].id) {
                _this.parSet2 = name
              }
            }
            if (name == _this.modelSku[i].sp3) {
              _this.parSet3 = name
            } else {
              if (id == _this.modelArr[2].id) {
                _this.parSet3 = name
              }
            }
            if (name == _this.modelSku[i].sp4) {
              _this.parSet4 = name
            } else {
              if (id == _this.modelArr[3].id) {
                _this.parSet4 = name
              }
            }
            if (name == _this.modelSku[i].sp5) {
              _this.parSet5 = name
            } else {
              if (id == _this.modelArr[4].id) {
                _this.parSet5 = name
              }
            }
            if (
              _this.parSet1 != '' &&
              _this.parSet2 != '' &&
              _this.parSet3 != '' &&
              _this.parSet4 != ''
            ) {
              if (
                _this.parSet1 == _this.modelSku[i].sp1 &&
                _this.parSet2 == _this.modelSku[i].sp2 &&
                _this.parSet3 == _this.modelSku[i].sp3 &&
                _this.parSet4 == _this.modelSku[i].sp4 &&
                _this.parSet5 == _this.modelSku[i].sp5
              ) {
                _this.goodsPrice = _this.modelSku[i].price
                _this.goodsSnId = _this.modelSku[i].id
                _this.goodsStock = _this.modelSku[i].stock
                _this.iconShow = true
                _this.number = 1
                _this.disableds = false
                return
              } else {
                _this.number = 0
                _this.disableds = true
                console.log('-----5-----')
              }
            }
          }
          break
        default:
          console.log('0')
          break
      }
    },
    // 修改数量-减少
    minus() {
      if (this.number != 0) {
        this.number = this.number > 1 ? this.number - 1 : 1
      }
    },
    // 修改数量-添加
    add() {
      if (this.number != 0) {
        this.number = this.number < 99 ? this.number + 1 : 99
      }
    },
    // 限制数量
    onInput(e) {
      console.log(e.target.value)
      this.number = e.target.value.replace(/[^\d]/g, '')
      if (this.number >= 99) {
        this.number = 99
      }
    },
    // 数量失去焦点
    onBlur(e) {
      console.log(e.target.value)
      e.target.value == '' ? (this.number = '1') : ''
    },
    // 收货地址
    async getAddress() {
      const res = await addrList()
      console.log(res)
      if (res.code == 200) {
        this.goodsAddress = res.data
        if(this.goodsAddress.length != 0) {
          this.freightAmount = this.goodsAddress[0].freightAmount
        }
      }
    },
    getAddr(e) {
      this.addressId = e.target.value
      localStorage.setItem('addressId', e.target.value)
      console.log(this.addressId)
      this.goodsAddress.map((item,key) => {
        if(this.addressId == item.id) {
          this.freightAmount = item.freightAmount
        }
      });
    },
    // 鼠标经过
    onImg(url, idx) {
      console.log(url)
      this.currImg = url
      this.currNum = idx
    },
    // 添加地址弹窗
    addressAdd() {
      this.addressShow = 1
    },
    // 关闭地址弹窗
    addressClose() {
      this.addressShow = 0
      this.addressName = ''
      this.addressPhone = ''
      this.addressDetail = ''
    },
    // 是否默认
    onDefault() {
      this.defaults == 1 ? (this.defaults = 0) : (this.defaults = 1)
    },
    // 收件人获取焦点
    addressNameFocus() {
      this.addressNameShow = 0
    },
    // 手机号获取焦点
    addressPhoneFocus() {
      this.addressPhoneShow = 0
    },
    // 详情地址获取焦点
    addressDetailFocus() {
      this.addressDetailShow = 0
    },
    // 添加收货地址
    async onSubmit() {
      let _this = this
      let myreg = /^1[345789]\d{9}$/
      if (_this.addressName == '') {
        _this.addressNameShow = 1
      }
      if (_this.addressPhone == '') {
        _this.addressPhoneShow = 1
        _this.addressPhoneMessage = '手机号码不能为空'
      }
      if (!myreg.test(_this.addressPhone)) {
        _this.addressPhoneShow = 1
        _this.addressPhoneMessage = '请输入正确的手机号码'
      }
      if (_this.addressDetail == '') {
        _this.addressDetailShow = 1
      }
      if (
        _this.addressName != '' &&
        _this.addressPhone != '' &&
        _this.addressDetail != '' &&
        myreg.test(_this.addressPhone)
      ) {
        this.addressShow = 0
        let codes = _this.areaCode == '' ? _this.provCode : _this.areaCode
        const res = await addrAdd({
          name: _this.addressName,
          phone: _this.addressPhone,
          postCode: codes,
          detailAddress: _this.addressDetail,
          defaultStatus: _this.defaults,
        })
        console.log(res)
        if (res.code == 200) {
          this.addressName = ''
          this.addressNameShow = 0
          this.addressPhone = ''
          this.addressPhoneShow = 0
          this.addressDetail = ''
          this.addressDetailShow = 0
          this.getAddress()
        }
      }
    },
    addrSplit(name) {
      return name.replace(/-/g, '')
      // .replace(/市辖区/g, "")
    },
    // 地址长度截取
    addrInter(text) {
      if (text.length >= 30) {
        return text.substring(0, 30) + '...'
      } else {
        return text
      }
    },
    // 立即购买
    onPay() {
      this.$layer.msg('请扫码右侧小程序二维码去下单')
      this.img_show = true
      return
      // if (this.number != 0) {
      //   this.$router.push({
      //     path: '/order',
      //     query: {
      //       goodsId: this.id,
      //       goodsSnId: this.goodsSnId,
      //       goodsNumber: this.number,
      //     },
      //   })
      // } else {
      //   this.$layer.msg('商品数量不能为空')
      // }
    },
    // 加入购物车
    async onCar() {
      this.$layer.msg('请扫码右侧小程序二维码去下单')
      this.img_show = true
      return
      // if (this.number != 0) {
      //   const res = await cartAdd({
      //     productId: this.id,
      //     productSkuId: this.goodsSnId,
      //     quantity: this.number,
      //   })
      //   console.log(res)
      //   if (res.code == 200) {
      //     this.$layer.msg('成功加入购物车')
      //     // this.carList()
      //   }
      // } else {
      //   this.$layer.msg('商品数量不能为空')
      // }
    },
    // 购物车列表
    // async carList(){
    //   const res = await cartList()
    //   console.log(res);
    //   if (res.code == 200) {
    //     this.$store.commit("modify", res.data.length)
    //     localStorage.setItem("carNum", res.data.length)
    //   }
    // },
    // 详情/评价
    detailEvalua(tab, e) {
      console.log(tab, e)
    },
    // 商品评价
    async loadEvalu() {
      const res = await productCommentList({
        id: this.id,
        pageSize: 100,
        pageNum: 1,
      })
      console.log(res)
      if (res.code == 200) {
        this.goodsEval = res.data.list
      }
    },
  },
}
</script>

<style scoped>
@import '../assets/styles/address.css';
.img_position1 {
  position: fixed;
  top: 400px;
  right: 150px;
  width: 200px;
  margin-bottom: 8px;
}
.position .title{
  cursor: default;
}
.detail_base {
  background: #fff;
}
.detail_base .left_img {
  float: left;
  width: 486px;
  display: flex;
}
.detail_base .left_img .top_img {
  width: 372px;
  height: 372px;
}
.detail_base .left_img .bottom_img {
  width: 115px;
  height: 386px;
  margin-top: -13px;
  margin-left: 14px;
  overflow: hidden;
  display: block;
  overflow-y:auto;
}
.detail_base .left_img .bottom_img li {
  float: left;
  display:inline-block;
  width: 83px;
  height: 83px;
  margin-right: 14px;
  margin-top: 13px;
  cursor: pointer;
}
.detail_base .left_img .bottom_img li.active,
.detail_base .left_img .bottom_img li:hover {
  border: solid 2px #ab9568;
}
.detail_base .left_img .bottom_img li img {
  float: left;
  width: 100%;
  height: 100%;
}
.detail_base .right_txt {
  float: right;
  width: 690px;
}
.detail_base .right_txt .title_z {
  width: 624px;
  /* height: 31px; */
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #222222;
  line-height: 28px;
}
.detail_base .right_txt .title_f {
  width: 437px;
  height: 19px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
}
/* 价格/配送 */
.detail_base .right_txt .price_deliv {
  width: 100%;
  height: 60px;
  padding: 24px 10px 0px;
  margin: 20px 0 0;
  background: #FFF8F9;
  overflow: hidden;
}
.detail_base .right_txt .price_deliv span1 {
  float: left;
  width: 46px;
  height: 18px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 18px;
}
.detail_base .right_txt .price_deliv span2 {
  float: left;
  color: #E71D35;
  font-size: 16px;
}
.detail_base .right_txt .price_deliv span3 {
  float: left;
  color: #E71D35;
  font-size: 24px;
  margin-top: -6px;
}
.detail_base .right_txt .price_deliv span4 {
  width: 58px;
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 17px;
  margin-left: 20px;
  text-decoration:line-through;
}
.detail_base .right_txt .price_pref {
  width: 100%;
  height: 60px;
  padding: 21px 10px 0px;
  background: #FFF4F5;
  overflow: hidden;
}
.detail_base .right_txt .price_pref span1 {
  float: left;
  width: 46px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 18px;
}
.detail_base .right_txt .price_pref span2 {
  float: left;
  width: 48px;
  height: 18px;
  border-radius: 2px;
  border: 1px solid #E71D35;
  color: #E71D35;
  text-align:center;
  padding-top: 2px;
}
.detail_base .right_txt .price_pref span3 {
  float: left;
  margin-left: 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
}
.detail_base .right_txt .price_pref span4 {
    padding-top: 4px;
    margin-left: 2px;
    float: left;
    color: #E71D35;
}
.detail_base .right_txt .price_pref span5 {
  margin-left: 30px;
  float: left;
  width: 48px;
  height: 18px;
  border-radius: 2px;
  border: 1px solid #E71D35;
  color: #E71D35;
  text-align:center;
  padding-top: 2px;
}
.detail_base .right_txt .price_pref span6 {
  margin-left: 10px;
  float: left;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
}
.detail_base .right_txt .price_pref span7 {
    padding-top: 4px;
    margin-left: 2px;
    float: left;
    color: #E71D35;
}
.detail_base .right_txt .goods_deliv {
  width: 100%;
  height: 40px;
  margin-top: 10px;
  padding: 11px 10px 0px;
  background: #FFFFFF;
  overflow: hidden;
}
.detail_base .right_txt .goods_deliv span1 {
  float: left;
  width: 46px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 18px;
}
/* .detail_base .right_txt .goods_deliv span {
  line-height: 26px;
}
.detail_base .right_txt .goods_deliv p {
  float: left;
  color: #333;
  line-height: 26px;
  padding-right: 8px;
} */
.detail_base .right_txt .goods_deliv .address_no {
  float: left;
  width: 300px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #666;
  text-align: center;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(220, 219, 217, 1);
  border-radius: 2px;
  cursor: pointer;
}
.detail_base .right_txt .goods_deliv .address_list,
.detail_base .right_txt .goods_deliv .address_list select,
.detail_base .right_txt .goods_deliv .address_list select option {
  float: left;
  cursor: pointer;
  width: 300px;
  height: 20px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
}
.detail_base .right_txt .goods_deliv .address_list select {
  color: #666;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(220, 219, 217, 1);
  border-radius: 1px;
} 
/* .detail_base .right_txt .goods_deliv .address_list select option {
  width: 300px;
  height: 20px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
} */
.detail_base .right_txt .goods_deliv span2 {
  float: left;
  margin-left: 22px;
  font-size: 13px;
  width: 150px;
  height: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
}
.detail_base .right_txt .goods_serv {
  width: 100%;
  height: 40px;
  margin-top: 10px;
  padding: 11px 10px 0px;
  background: #FFFFFF;
  overflow: hidden;
}
.detail_base .right_txt .goods_serv span1 {
  float: left;
  width: 46px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 18px;
}
.detail_base .right_txt .goods_serv span2 {
  width: 265px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
}
.detail_base .right_txt .goods_weight {
  width: 100%;
  height: 60px;
  margin-top: 20px;
  padding: 11px 10px 0px;
  background: #FFFFFF;
  overflow: hidden;
}
.detail_base .right_txt .goods_weight span1 {
  float: left;
  width: 46px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 18px;
}
.detail_base .right_txt .goods_weight span2 {
  width: 265px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
}
.detail_base .right_txt .goods_num {
  width: 100%;
  height: 40px;
  margin-top: 30px;
  padding: 11px 10px 0px;
  background: #FFFFFF;
  overflow: hidden;
}
.detail_base .right_txt .goods_num span1 {
  float: left;
  width: 46px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 18px;
}
.detail_base .right_txt .goods_num .right .number {
  float: left;
  margin-top: -6px;
}
.detail_base .right_txt .goods_num .right .number div {
  float: left;
  width: 30px;
  height: 30px;
  line-height: 25px;
  text-align: center;
  border: solid 1px #e2e2e2;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.detail_base .right_txt .goods_num .right .number div.minus,
.detail_base .right_txt .goods_num .right .number div.add {
  color: #999;
  font-size: 20px;
  cursor: pointer;
}
.detail_base .right_txt .goods_num .right .number div.minus.active,
.detail_base .right_txt .goods_num .right .number div.add.active {
  color: #e2e2e2;
  cursor: not-allowed;
}
.detail_base .right_txt .goods_num .right .number div.num {
  color: #666;
  width: 46px;
  border-left: none;
  border-right: none;
  overflow: hidden;
}
.detail_base .right_txt .goods_num .right .number div.num input {
  float: left;
  color: #666;
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border: none;
  background: #fff;
}
/* 规格 */
.detail_base .model_list {
  width: 100%;
  margin-top: 10px;
  overflow: hidden;
}
.detail_base .model_list .left {
  float: left;
  color: #666;
  width: 64px;
  line-height: 35px;
  padding-top: 14px;
  padding-left: 12px;
}
.detail_base .model_list .right {
  float: left;
  width: 620px;
}
.detail_base .model_list .right span {
  float: left;
  cursor: pointer;
  height: 35px;
  margin: 14px 14px 0 0;
  position: relative;
  overflow: hidden;
}
.detail_base .model_list .right span p {
  color: #333;
  height: 35px;
  line-height: 33px;
  padding: 0 18px;
  border: solid 1px #dadada;
}
.detail_base .model_list .right span p.on_show {
  border-color: #E71D35;
}
.detail_base .model_list .right span i {
  width: 19px;
  height: 19px;
  background: url('../assets/images/icon_0.png') 0 -183px no-repeat;
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 3;
}
.detail_base .model_list .right .number {
  float: left;
  margin-top: 14px;
}
.detail_base .model_list .right .number div {
  float: left;
  width: 40px;
  height: 35px;
  line-height: 33px;
  text-align: center;
  border: solid 1px #e2e2e2;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.detail_base .model_list .right .number div.minus,
.detail_base .model_list .right .number div.add {
  color: #999;
  font-size: 20px;
  cursor: pointer;
}
.detail_base .model_list .right .number div.minus.active,
.detail_base .model_list .right .number div.add.active {
  color: #e2e2e2;
  cursor: not-allowed;
}
.detail_base .model_list .right .number div.num {
  color: #666;
  width: 67px;
  border-left: none;
  border-right: none;
  overflow: hidden;
}
.detail_base .model_list .right .number div.num input {
  float: left;
  color: #666;
  width: 100%;
  height: 33px;
  line-height: 33px;
  text-align: center;
  border: none;
  background: #fff;
}
.detail_base .btn {
  width: 100%;
  margin-top: 40px;
  overflow: hidden;
}
.detail_base .btn div {
  float: left;
  width: 183px;
  height: 54px;
  font-size: 20px;
  line-height: 52px;
  margin-left: 12px;
  cursor: pointer;
  position: relative;
}
.detail_base .btn div.btn_pay {
  /* color: rgba(180, 160, 120, 1);
  text-align: center;
  background: rgba(245, 243, 239, 1);
  border: 1px solid rgba(180, 160, 120, 1); */
  width: 200px;
  height: 48px;
  background: linear-gradient(90deg, #E1041C 0%, #FA3145 100%);
  border-radius: 8px;
  margin-left: 30px;
}
.detail_base .btn div.btn_car {
  /* padding-left: 51px;
  color: rgba(255, 255, 255, 1);
  background: rgba(180, 160, 120, 1);
  border: 1px solid rgba(180, 160, 120, 1); */
  width: 200px;
  height: 48px;
  background: linear-gradient(90deg, #FD7000 0%, #FD8E00 100%);
  border-radius: 8px;
}
.detail_base .btn div.btn_car p,
.detail_base .btn div.btn_pay p {
  width: 200px;
  height: 21px;
  font-size: 15px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 21px;
  margin-top: 13px;
  text-align:center;
  line-height: 21px;
}
/* .detail_base .btn div.btn_car::before {
  content: '';
  width: 23px;
  height: 23px;
  background: url('../assets/images/icon_0.png') 0 -202px no-repeat;
  position: absolute;
  top: 15px;
  left: 21px;
} */
.detail_base .btn div.btn_pay.active,
.detail_base .btn div.btn_car.active {
  cursor: not-allowed;
  color: #ccc;
  background: #f3f3f3;
  border: 1px solid #d6d6d6;
}
/* 商品详情 */
.goods_detail {
  /* float: left;
  width: 1200px;
  border-top: 1px solid rgba(171, 149, 104, 1);
  margin: 50px auto 0;
  background: #fff;
  display: flex; */
}
.item_list{
  float: left;
  padding-top: 40px;
  width: 350px;
  min-height: 150px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.item_list li{
  width: 314px;
  padding-right: 0px;
  text-align: center;
  padding-bottom: 0px;
  margin-top: 10px;
  margin-left: 3px;
  margin-right: 9px;
  margin-bottom: 0px;
  overflow: hidden;
  background: #FFFFFF;
}
.item_list li .img,
.item_list li .img img{
  float: left;
  width: 314px;
  height: 314px;
}
.item_list li .title{
  display: inline-block;
  color: #333;
  max-width: 100%;
  padding: 0 10px;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 314px;
  height: 52px;
  font-size: 14px;
  padding-top: 14px;
}
.item_list li .price{
  padding-top: 21px;
  padding-bottom: 21px;
}
.item_list li .price span{
  font-size: 14px;
  display: inline-block;
  vertical-align: top;
  color: #DA2833;
  padding-right: 6px
}
.item_list li .price del{
  font-size: 10px;
  display: inline-block;
  vertical-align: bottom;
  color: #999;
}
.detail_comment {
  float: right;
  width: 790px;
  border-top: 1px solid #E8E8E8;
  margin: 50px auto 0;
  background: #fff;
  display: flex;
}
.goods_detail .el-tabs >>> .el-tabs__header {
  margin-bottom: 32px;
  background: rgba(245, 245, 245, 1);
  
}
.goods_detail .el-tabs >>> .el-tabs__item {
  padding: 0;
  /* width: 395px; */
  width: 790px;
  height: 50px;
  line-height: 48px;
  text-align: center;
  z-index: 3;
    font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #999999;
  
}
.goods_detail .el-tabs >>> .el-tabs__item:hover,
.goods_detail .el-tabs >>> .el-tabs__item.is-active {
  border-top: 1px solid #E71D35;
  background-color: #FFFFFF;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #E71D35;
  line-height: 48px;
}
.goods_detail .el-tabs >>> .el-tabs__active-bar {
  height: 100%;
  background-color: #fff;
    font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #E71D35;
  line-height: 28px;
}
.goods_detail .el-tabs >>> .el-tabs__nav-wrap::after {
  height: 0;
  overflow: hidden;
}
.goods_detail .detail {
  font-size: 0;
  line-height: 0;
  text-align: center;
  padding-bottom: 80px;
}
.goods_detail .detail >>> p {
  font-size: 0;
  line-height: 0;
}
</style>